import { useState } from "react";
import Trans from "features/translation/components/Trans";
import Dialog from "components/ui/Dialog/Dialog";
import Button from "components/ui/Button/Button";
import Input from "components/form/Input/Input";
import useData from "hooks/useData";
import Loader from "components/ui/Loader/Loader";
import Alert from "components/ui/Alert/Alert";
import { useDialog } from "context/DialogContext";
import LoginDialog from "features/authentication/components/LoginDialog";

const PasswordCreate = ({ token, crmId }) => {
  const [done, setDone] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { showDialog, hideDialog } = useDialog();
  const { postData } = useData();

  const handleReset = () => {

    const send = async () => {
      setDone(false);
      setError(null);
      setLoading(true);
      const result = await postData(
        'rest/stb/password',
        {
          'password': password,
          'token': token,
          'crm_id': crmId || ``,
        },
        false
      );

      setLoading(false);
      if (result?.status === 200) {
        setDone(true);
      } else {
        setError('Het aanmaken van uw account is niet gelukt. Probeer het opnieuw of neem contact op met de ledenservice als het probleem blijft bestaan.');
      }
    }

    if (!password) {
      setError('U heeft nog geen wachtwoord opgegeven.');
      return;
    }

    if (confirmPassword !== password) {
      setError('De ingevulde wachtwoorden komen niet overeen.');
      return;
    }

    send();
  }

  return (
    <Dialog title={ `Wachtwoord instellen` }>
      { loading && <Loader/> }
      { !token && <Alert title={ `Token ontbreekt` }
                         message={ `De link is niet geldig, probeer de link uit uw mail opnieuw te openen of vraag een nieuwe link op.` }/> }
      {
        done &&
        <>
          <p>Uw account is aangemaakt. U kunt nu inloggen met het ingestelde wachtwoord.</p>
          <div className="dialog__buttons">
            <Button variant={ `primary` } onClick={ () => hideDialog() }>Sluiten</Button>
            <Button variant={ `secondary` } onClick={ () => showDialog(<LoginDialog/>) }>Inloggen</Button>
          </div>
        </>
      }
      {
        !loading && !done && token &&
        <>
          { error && <Alert message={ error }/> }
          <p>
            <Trans
              text="Vul hieronder een wachtwoord in voor uw Trefpunt account en druk op 'Opslaan' om uw wachtwoord in te stellen."/>
          </p>
          <div className={ `dialog__row` }>
            <Input
              type={ `password` }
              onChange={ event => setPassword(event.target.value) }
              value={ password }
              placeholder={ `Uw wachtwoord` }
            />
          </div>
          <div className={ `dialog__row` }>
            <Input
              type={ `password` }
              onChange={ event => setConfirmPassword(event.target.value) }
              value={ confirmPassword }
              placeholder={ `Bevestig uw wachtwoord` }
            />
          </div>
          <div className="dialog__buttons">
            <Button onClick={ () => hideDialog() }>Annuleren</Button>
            <Button variant={ `secondary` } onClick={ handleReset }>Opslaan</Button>
          </div>

        </>
      }
    </Dialog>
  )
}

export default PasswordCreate;
